import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { fetchNotificationDetails } from "../../../redux/slices/notificationsSlice";
import { ChevronDownIcon } from "../../../utils/svgIcons";
import { Accordion, AccordionItem, Tooltip, Button, Spinner, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@heroui/react";
import { MdOutlineRemoveRedEye } from "react-icons/md";

const ALERT_TYPE_LABELS = {
  1: "EV News",
  2: "New Launches",
  3: "Offers & Discounts",
  4: "Upcoming Vehicles"
};

export default function SentList({ items, expanded, setExpanded }) {
  const [search, setSearch] = useState("");
  const [dateFilter, setDateFilter] = useState("all");
  const [viewDetails, setViewDetails] = useState(null);
  const [loadingDetailsId, setLoadingDetailsId] = useState(null);
  const dispatch = useDispatch();

  const handleView = (id) => {
    setLoadingDetailsId(id);
    dispatch(fetchNotificationDetails(id))
      .unwrap()
      .then((data) => {
        setViewDetails(data);
      })
      .catch((err) => {
        console.error("Failed to fetch notification details:", err);
      })
      .finally(() => {
        setLoadingDetailsId(null);
      });
  };

  const normalized = (items || []).map((i) => ({
    id: i.id || i._id,
    title: i.title || "Untitled Notification",
    sentAt: i.sentAt || i.updatedAt || i.createdAt,
    targetUsers:
      typeof i.targetUsers === "number"
        ? i.targetUsers
        : (i.matched_emails?.length || 0) +
        (i.matched_browser_ids?.length || 0) +
        (i.matched_phones?.length || 0),
    details:
      i.details || {
        "Alert Type": ALERT_TYPE_LABELS[i.alert_type] || i.alert_type,
        Vehicle: i.vehicleData?.title,
        Brand: i.vehicleData?.company_title,
        "Price (₹)": i.vehicleData?.total_price?.toLocaleString?.(),
        Link: i.link,
      },
  }));

  const filtered = normalized
    .filter((i) => (i.title || "").toLowerCase().includes(search.toLowerCase()))
    .filter((i) => {
      if (dateFilter === "all") return true;
      const sentDate = new Date(i.sentAt || i.updatedAt || i.createdAt);
      const now = new Date();
      if (dateFilter === "today") {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return sentDate >= start;
      }
      let limit = new Date();
      if (dateFilter === "last7days") limit.setDate(now.getDate() - 7);
      if (dateFilter === "last30days") limit.setDate(now.getDate() - 30);
      return sentDate >= limit;
    });

  return (
    <>

      {/* List */}
      {/* {filtered.length > 0 ? (
        filtered.map((item) => {
          const isOpen = expanded === item.id;
          return (
            <div
              key={item.id}
              className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden transition-shadow duration-300"
            >
              <div
                className="p-4 md:p-6 flex justify-between items-center cursor-pointer hover:bg-gray-50"
                onClick={() => setExpanded(isOpen ? null : item.id)}
              >
                <div className="flex-grow">
                  <h3 className="font-semibold text-gray-800">{item.title}</h3>
                  <div className="flex items-center flex-wrap gap-x-4 text-xs text-gray-500 mt-1">
                    <span>ID: {item.id}</span>
                    <span>Sent: {new Date(item.sentAt).toLocaleString()}</span>
                  </div>
                </div>
                <div className="ml-4 flex-shrink-0">
                  <ChevronDownIcon isOpen={isOpen} />
                </div>
              </div>
              {isOpen && (
                <div className="border-t border-gray-200 p-6 bg-gray-50">
                  <h4 className="font-semibold text-gray-700 mb-2">
                    Full Notification Data
                  </h4>
                  <p className="text-sm text-gray-500 mb-4">
                    This notification was sent to{" "}
                    <span className="font-semibold text-gray-700">
                      {item.targetUsers.toLocaleString()}
                    </span>{" "}
                    users.
                  </p>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 text-sm">
                    {Object.entries(item.details).map(([key, value]) => (
                      <div key={key}>
                        <p className="text-gray-500">{key}</p>
                        <p className="font-medium text-gray-800">{value}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        })
      ) : ( */}
      {filtered.length > 0 ? (
        <Accordion
          variant="light"
          selectionMode="single"
          className="space-y-4"
          itemClasses={{
            base: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden",
            trigger:
              "p-4 md:p-6 flex justify-between items-center cursor-pointer hover:bg-gray-50",
            title: "w-full",
            indicator: "ml-4 transition-transform",
            content: "border-t border-gray-200 p-6 bg-gray-50",
          }}
        >
          {filtered.map((item) => (
            <AccordionItem
              key={item.id}
              aria-label={item.title}
              title={
                <div className="flex justify-between w-full items-center pr-4">
                  <div>
                    <h3 className="font-semibold text-gray-800">
                      {item.title}
                    </h3>
                    <div className="flex items-center flex-wrap gap-x-4 text-xs text-gray-500 mt-1">
                      <span>ID: {item.id}</span>
                      <span>
                        Sent: {new Date(item.sentAt || item.updatedAt || item.createdAt).toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center" onClick={(e) => e.stopPropagation()}>
                    <Tooltip content="View Details" delay={0} closeDelay={0}>
                      <Button
                        isIconOnly
                        variant="flat"
                        size="md"
                        isLoading={loadingDetailsId === item.id}
                        onClick={() => handleView(item.id)}
                        className="p-2 text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-800 transition-all duration-200 flex items-center justify-center"
                      >
                        {loadingDetailsId !== item.id ? <MdOutlineRemoveRedEye className="w-4 h-4" /> : <Spinner size="sm" color="current" />}
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              }
              indicator={<ChevronDownIcon />}
            >
              <h4 className="font-semibold text-gray-700 mb-2">
                Full Notification Data
              </h4>
              <p className="text-sm text-gray-500 mb-4">
                This notification was sent to{" "}
                <span className="font-semibold text-gray-700">
                  {(item.targetUsers ?? 0).toLocaleString()}
                </span>{" "}
                users.
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                {Object.entries(item.details || {}).map(([key, value]) => (
                  <div key={key}>
                    <p className="text-gray-500">{key}</p>
                    <p className="font-medium text-gray-800 select-text">{value}</p>
                  </div>
                ))}
              </div>
            </AccordionItem>
          ))}
        </Accordion>
      ) : (
        <div className="text-center py-12 bg-white rounded-lg shadow-sm border">
          <h3 className="text-lg font-medium text-gray-700">
            No Sent Notifications
          </h3>
          <p className="text-gray-500 mt-1">
            The history of sent notifications will appear here.
          </p>
        </div>
      )}

      {viewDetails && (
        <Modal
          isOpen
          size="3xl"
          scrollBehavior="inside"
          backdrop="blur"
          onOpenChange={() => setViewDetails(null)}
          classNames={{
            base: "max-w-[850px] bg-white rounded-2xl shadow-2xl border border-gray-100",
            header: "border-b border-gray-100 px-6 py-4 bg-gray-50/50 rounded-t-2xl",
            body: "p-6",
            footer: "border-t border-gray-100 px-6 py-4 bg-gray-50/50 rounded-b-2xl",
          }}
        >
          <ModalContent>
            <ModalHeader className="flex flex-col gap-1">
              <div className="flex items-center space-x-3">
                <span className={`px-2.5 py-1 text-xs font-semibold rounded-full ${
                  viewDetails.review_needed
                    ? "bg-red-100 text-red-800"
                    : "bg-green-100 text-green-800"
                }`}>
                  {viewDetails.review_needed ? "Review Needed" : "Perfect Match"}
                </span>
                <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                  {ALERT_TYPE_LABELS[viewDetails.alert_type] || "General Alert"}
                </span>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mt-2 select-text">
                {viewDetails.title}
              </h2>
            </ModalHeader>
            <ModalBody className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="md:col-span-2 space-y-4">
                  {viewDetails.image_url && (
                    <div className="rounded-xl overflow-hidden border border-gray-200 bg-gray-50 aspect-video flex items-center justify-center">
                      <img
                        src={viewDetails.image_url}
                        alt={viewDetails.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  <div>
                    <h3 className="text-sm font-semibold text-gray-500 tracking-wider mb-2">
                      Description
                    </h3>
                    <div
                      className="prose prose-sm max-w-none text-gray-800 bg-gray-50 p-4 rounded-xl border border-gray-100 select-text"
                      dangerouslySetInnerHTML={{ __html: viewDetails.description }}
                    />
                  </div>
                  {viewDetails.link && (
                    <div>
                      <h3 className="text-sm font-semibold text-gray-500 tracking-wider mb-1">
                        Target Action Link
                      </h3>
                      <a
                        href={viewDetails.link}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 hover:text-blue-800 font-medium break-all underline text-sm select-text"
                      >
                        {viewDetails.link}
                      </a>
                    </div>
                  )}
                </div>

                <div className="space-y-4 bg-gray-50/50 p-4 rounded-xl border border-gray-100">
                  <div>
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                      Created At
                    </h3>
                    <p className="text-sm text-gray-700 font-medium select-text">
                      {new Date(viewDetails.createdAt).toLocaleString()}
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                      Last Updated
                    </h3>
                    <p className="text-sm text-gray-700 font-medium select-text">
                      {new Date(viewDetails.updatedAt).toLocaleString()}
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                      Custom Created
                    </h3>
                    <p className="text-sm text-gray-700 font-medium">
                      {viewDetails.isCustom ? "Yes" : "No"}
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                      Target Preferences
                    </h3>
                    <p className="text-sm text-gray-700 font-medium select-text">
                      {viewDetails.preference_ids?.length || 0} user preferences
                    </p>
                  </div>

                  {viewDetails.vehicleData && (
                    <div className="pt-2 border-t border-gray-200 mt-2">
                      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                        Associated Vehicle
                      </h4>
                      <div className="text-sm space-y-1">
                        <p className="font-semibold text-gray-800 select-text">
                          {viewDetails.vehicleData.title}
                        </p>
                        <p className="text-xs text-gray-500">
                          Brand: <span className="font-medium text-gray-700 select-text">{viewDetails.vehicleData.company_title}</span>
                        </p>
                        <p className="text-xs text-gray-500">
                          Price: <span className="font-medium text-gray-700 select-text">₹{viewDetails.vehicleData.total_price?.toLocaleString()}</span>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="border-t border-gray-100 pt-6">
                <h3 className="text-base font-bold text-gray-800 mb-3 flex items-center space-x-2">
                  <span>Target Reach Info</span>
                  <span className="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full font-semibold">
                    {((viewDetails.matched_emails?.length || 0) + (viewDetails.matched_phones?.length || 0) + (viewDetails.matched_browser_ids?.length || 0))} matches
                  </span>
                </h3>

                <div className="space-y-4">
                  <div>
                    <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                      Emails ({viewDetails.matched_emails?.length || 0})
                    </h4>
                    {viewDetails.matched_emails && viewDetails.matched_emails.length > 0 ? (
                      <div className="flex flex-wrap gap-1.5 max-h-24 overflow-y-auto p-2 bg-gray-50 rounded-lg border border-gray-100 select-text">
                        {viewDetails.matched_emails.map((email, idx) => (
                          <span key={idx} className="bg-white border border-gray-200 px-2 py-0.5 rounded text-xs text-gray-600 font-medium">
                            {email}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <p className="text-xs text-gray-400 italic">No emails matched</p>
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                        Phone Numbers ({viewDetails.matched_phones?.length || 0})
                      </h4>
                      {viewDetails.matched_phones && viewDetails.matched_phones.length > 0 ? (
                        <div className="flex flex-wrap gap-1.5 max-h-24 overflow-y-auto p-2 bg-gray-50 rounded-lg border border-gray-100 select-text">
                          {viewDetails.matched_phones.map((phone, idx) => (
                            <span key={idx} className="bg-white border border-gray-200 px-2 py-0.5 rounded text-xs text-gray-600 font-medium">
                              {phone}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p className="text-xs text-gray-400 italic">No phone numbers matched</p>
                      )}
                    </div>

                    <div>
                      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                        Browser Notifications ({viewDetails.matched_browser_ids?.length || 0})
                      </h4>
                      {viewDetails.matched_browser_ids && viewDetails.matched_browser_ids.length > 0 ? (
                        <div className="p-2 bg-gray-50 rounded-lg border border-gray-100 text-xs text-gray-600 select-text font-medium">
                          Targeted {viewDetails.matched_browser_ids.length} browser subscriber endpoints.
                        </div>
                      ) : (
                        <p className="text-xs text-gray-400 italic">No browser notification endpoints matched</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onPress={() => setViewDetails(null)}
                className="px-6 py-2 bg-button text-white rounded-lg font-semibold hover:bg-button/90"
              >
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}
